import { render, staticRenderFns } from "./ProgramaForm.vue?vue&type=template&id=4be68030&scoped=true"
import script from "./ProgramaForm.vue?vue&type=script&lang=js"
export * from "./ProgramaForm.vue?vue&type=script&lang=js"
import style0 from "./ProgramaForm.vue?vue&type=style&index=0&id=4be68030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be68030",
  null
  
)

export default component.exports